var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.orderId)?_c('text-link',{attrs:{"to":{name: 'orders.edit', params: {order: this.orderId}}}},[_vm._v(" #"+_vm._s(_vm.orderId)+" ")]):_c('span',[_vm._v("/")])
}
var staticRenderFns = []

export { render, staticRenderFns }